import React, { Component } from 'react'
import AppsPageHeader from './AppsPageHeader'
import AppsHeroSection from './AppsHeroSection'
import YourAppsSection from './YourAppsSection'
import AppSection from './AppSection'
import { connect } from 'react-redux'
import GetStartedSection from './GetStartedSection'
import { fetchApps } from 'api/developerApi'
import { showTransientNotification } from '@driftt/traffic-control'
import './style.css'

class AppsPage extends Component {
  state = {
    apps: []
  }

  componentDidMount() {
    this.fetchApps()
  }

  fetchApps = () => {
    const onDone = (apps) => {
      this.setState({ apps })
    }
    const onError = () => {
      this.props.showErrorNotification('We couldn’t fetch your apps. Please refresh the page.')
    }

    fetchApps()
      .then(onDone)
      .catch(onError)
  }

  resolveAppItems = () => {
    const { apps } = this.state
    const { showErrorNotification } = this.props

    let appItems = apps.map(app => (
      <AppSection
        key={app.id}
        id={app.id}
        name={app.name}
        description={app.shortDescription}
        iconUrl={app.iconUrl}
        showErrorNotification={showErrorNotification}
        onAppDeleted={this.fetchApps}
      />
    ))

    appItems.push(
      <GetStartedSection key="get-started" showErrorNotification={showErrorNotification} />
    )

    return appItems
  }


  render() {
    const appItems = this.resolveAppItems()
    const { showErrorNotification } = this.props

    return (
      <div className="apps-page">
        <AppsPageHeader />
        <AppsHeroSection showErrorNotification={showErrorNotification} />
        <YourAppsSection className="apps-page-your-apps" />
        <div className="apps-page-items">
          {appItems}
        </div>
      </div>
    )
  }
}

const mapStateToProps = null
const mapDispatchToProps = dispatch => ({
  showErrorNotification: (message) => dispatch(showTransientNotification({ type: 'error', message }))
})

export default connect(mapStateToProps, mapDispatchToProps)(AppsPage)
